import { render, staticRenderFns } from "./index.vue?vue&type=template&id=468e5210&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468e5210')) {
      api.createRecord('468e5210', component.options)
    } else {
      api.reload('468e5210', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=468e5210&", function () {
      api.rerender('468e5210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/vacation-types/components/remove-type-modal/index.vue"
export default component.exports